import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import {
  Avatar,
  Badge,
  Box,
  Checkbox,
  Fab,
  FormControl,
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import { useRecoilState } from "recoil";
import { debounce, set } from "lodash";
import { get, post } from "../Services/services";
import { wholeNumberRegex } from "../Regex/Regex";
import { UserAuthState } from "../Services/RecoilService";
import { useLocation } from "react-router-dom";
import { _getCase } from "../Services/api-services";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function DiscountDialog(props) {
  const [discountReason, setDiscountReason] = React.useState({});
  const [occupation, setOccupation] = React.useState({});
  const [familyIncome, setFamilyIncome] = React.useState({});
  const [authState, setAuthState] = useRecoilState(UserAuthState);
  const { state } = useLocation();
  const caseId = state?.id;

  const [formData, setFormData] = React.useState({
    requestedAmount: "",
    reasonId: "",
    reasonComment: "",
    parentOccupation: "",
    annualFamilyIncome: "",
    numberOfEarningMember: "",
    terms: false,
  });

  const getDesignation = async () => {
    const res = await post("fieldTypes/getAllFieldTypeWithField", {
      status: true,
    });

    if (res.statusCode === 200) {
      res.data?.forEach((item) => {
        if (item.title === "discount request reasons") {
          setDiscountReason(item);
        } else if (item.title === "parent occupation") {
          setOccupation(item);
        } else if (item.title === "annual family income") {
          setFamilyIncome(item);
        }
      });
    }
  };

  async function fetchCaseData() {
    try {
      let body = {
        caseId: caseId,
      };
      const response = await _getCase(body);
      const caseDetails = response.case;
      
      // Get parent occupation from case details
      const parentOccupation = caseDetails?.fatherOccupation || caseDetails?.motherOccupation;
      
      // If we have both occupation data and parent occupation from case details
      if (occupation?.field && parentOccupation) {
        // Find the matching occupation in our occupation field options
        const matchingOccupation = occupation.field.find(
          (item) => item.title.toLowerCase() === parentOccupation.toLowerCase()
        );
        
        // If found, set it in the form data
        if (matchingOccupation) {
          setFormData(prevState => ({
            ...prevState,
            parentOccupation: matchingOccupation._id
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching case data:", error);
    }
  }

  React.useEffect(() => {
    getDesignation();
  }, [props.open]);

  // Only fetch case data after occupation data is loaded
  React.useEffect(() => {
    if (occupation?.field?.length > 0 && caseId) {
      fetchCaseData();
    }
  }, [occupation, caseId]);

  const handleAddDiscountRequest = async (formData,authState,props) => {
    let body = formData;
    body.adminId = authState?.userId;
    body.status = "pending";
    body.subscribedCoursesId = props?.courseData?._id;
    body.batchId = props?.courseData?.batchId;
    body.preApproved = false;
    body.deleted = false;
    body.courseId = props?.courseData?.courseId;
    body.caseId = props?.courseData?.caseId;
    
    const res = await post("discountRequests", body);
    if (res?.statusCode === 200) {
      props.setDiscountDialog(false);
      props.refreshCase();
    }
  };
    const debounceSearch = React.useCallback(debounce(handleAddDiscountRequest, 300), []);

  return (
    <React.Fragment>
      <BootstrapDialog
        fullWidth
        onClose={() => {
          props.setDiscountDialog(false);
        }}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Discount request
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => {
            props.setDiscountDialog(false);
          }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Box className="flex flex-col gap-10 p-5">
            <Box className="flex gap-4">
              <TextField
                required
                label="DISCOUNT AMOUNT"
                fullWidth
                size="small"
                value={formData.requestedAmount}
                helperText={
                  (!wholeNumberRegex?.test(formData?.requestedAmount) ||
                    formData?.requestedAmount >=
                      props.courseData?.unpaidAmount) &&
                  formData?.requestedAmount?.length !== 0
                    ? `Discount amount only contains number and not greater then or equal unpaid fee ${props.courseData?.unpaidAmount}`
                    : ""
                }
                error={
                  (!wholeNumberRegex?.test(formData?.requestedAmount) ||
                    formData?.requestedAmount >=
                      props.courseData?.unpaidAmount) &&
                  formData?.requestedAmount?.length !== 0
                }
                onChange={(e) => {
                  setFormData((prevState) => ({
                    ...prevState,
                    requestedAmount: e.target.value,
                  }));
                }}
              />
            </Box>
            <Box className="flex gap-4">
              <TextField
                required
                label="NO OF EARNING MEMBERS IN FAMILY"
                fullWidth
                size="small"
                value={formData.numberOfEarningMember}
                error={
                  !wholeNumberRegex?.test(formData?.numberOfEarningMember) &&
                  formData?.numberOfEarningMember?.length !== 0
                }
                helperText={
                  !wholeNumberRegex?.test(formData?.numberOfEarningMember) &&
                  formData?.numberOfEarningMember?.length !== 0
                    ? "No of earning members in family only contain numbers"
                    : ""
                }
                onChange={(e) => {
                  setFormData((prevState) => ({
                    ...prevState,
                    numberOfEarningMember: e.target.value,
                  }));
                }}
              />
            </Box>
            <Box className=" flex gap-4">
              <TextField
                required
                label="REASON"
                fullWidth
                multiline
                rows={4}
                size="small"
                value={formData.reasonComment}
                onChange={(e) => {
                  setFormData((prevState) => ({
                    ...prevState,
                    reasonComment: e.target.value,
                    reasonId: e.target.value ? "comment-based-reason" : "",
                  }));
                }}
              />
            </Box>
            
            <Box>
              <FormControl fullWidth size="small">
                <InputLabel id="occupation-label">PARENT OCCUPATION</InputLabel>
                <Select
                  labelId="occupation-label"
                  id="occupation"
                  value={formData.parentOccupation}
                  label="PARENT OCCUPATION"
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      parentOccupation: e.target.value,
                    })
                  }
                >
                  {occupation?.field?.map((item) => (
                    <MenuItem key={item._id} value={item._id}>
                      {item.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            
            <Box>
              <FormControl
                required
                fullWidth
                size="small"
              >
                <InputLabel id="family-income-label">
                  ANNUAL FAMILY INCOME
                </InputLabel>
                <Select
                  labelId="family-income-label"
                  id="family-income"
                  value={formData.annualFamilyIncome}
                  label="ANNUAL FAMILY INCOME"
                  onChange={(e) => {
                    setFormData((prevState) => ({
                      ...prevState,
                      annualFamilyIncome: e.target.value,
                    }));
                  }}
                >
                  {familyIncome?.field?.map((item) => (
                    <MenuItem key={item._id} value={item._id}>
                      {item.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Box className="flex">
              <div>
                <Checkbox
                  checked={formData.terms}
                  onChange={() => {
                    setFormData((prevState) => ({
                      ...prevState,
                      terms: !formData.terms,
                    }));
                  }}
                  className="items-start"
                />
              </div>
              <p>
                I have informed student that he's responsible for the
                authenticity of the reason and related information produced here
                for additional discount. All the above information shall be
                found valid upon verification.
              </p>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ backgroundColor: "#3366FF" }}
            variant="contained"
            disabled={
              !wholeNumberRegex?.test(formData?.requestedAmount) ||
              !wholeNumberRegex?.test(formData?.numberOfEarningMember) ||
              !formData?.reasonComment ||
              !formData?.parentOccupation ||
              !formData?.annualFamilyIncome ||
              formData?.requestedAmount >= props.courseData?.unpaidAmount ||
              !formData?.terms
            }
            autoFocus
            onClick={() => debounceSearch(formData,authState,props)}
          >
            Add
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}